import { Box } from '@mui/material'
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined'
import { BoxCard, Chip, Grid, Section, Typography } from 'src/lib'
import { FILE_TYPES } from './types'

interface IFileTypeSectionProps {
    platform: string
    selectedFileType: string | null
    onSelect: (id: string) => void
}

const FileTypeSection = ({ platform, selectedFileType, onSelect }: IFileTypeSectionProps) => {
    const fileTypes = FILE_TYPES[platform] ?? []

    return (
        <Section
            icon={<ArticleOutlinedIcon />}
            title="Tipo de arquivo"
            subtitle="Selecione o tipo de arquivo a importar"
        >
            <Grid container gap={2}>
                {fileTypes.map((ft) => (
                    <BoxCard
                        key={ft.id}
                        onClick={ft.available ? () => onSelect(ft.id) : undefined}
                        sx={{
                            position: 'relative',
                            width: 200,
                            minHeight: 72,
                            p: 2,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            cursor: ft.available ? 'pointer' : 'default',
                            opacity: ft.available ? 1 : 0.4,
                            transition: 'border-color 0.15s ease, background-color 0.15s ease',
                            ...(selectedFileType === ft.id && {
                                borderColor: 'primary.main',
                                bgcolor: 'rgba(162, 205, 237, 0.06)',
                            }),
                            ...(ft.available && {
                                '&:hover': { borderColor: 'primary.main' },
                            }),
                        }}
                    >
                        {!ft.available && (
                            <Box sx={{ position: 'absolute', top: 6, right: 6 }}>
                                <Chip label="Em breve" color="neutral" size="small" />
                            </Box>
                        )}
                        <Typography variant="h3">{ft.label}</Typography>
                        <Typography variant="caption">{ft.description}</Typography>
                    </BoxCard>
                ))}
            </Grid>
        </Section>
    )
}

export { FileTypeSection }
